import { localize } from "@/utils/i18n";

const textLocalize = {
    title: localize({
        ru: 'Подать заявку',
        en: 'Apply now',
        cn: 'Apply now'
    }),
    programs: localize({
        ru: 'Программа',
        en: 'Program',
        cn: 'Program'
    }),
    institutionName: localize({
        ru: 'Название учебного заведения',
        en: 'Institution name',
        cn: 'Institution name'
    }),
    fio: localize({
        ru: 'ФИО представителя учебного заведения',
        en: 'Full name of the representative',
        cn: 'Full name of the representative'
    }),
    position: localize({
        ru: 'Должность представителя учебного заведения',
        en: 'Position of representative',
        cn: 'Position of representative'
    }),
    phone: localize({
        ru: 'Контактный телефон',
        en: 'Contact phone number',
        cn: 'Contact phone number'
    }),
    email: localize({
        ru: 'Контактный email',
        en: 'Contact email',
        cn: 'Contact email'
    }),
    file: localize({
        ru: 'Файл',
        en: 'File',
        cn: 'File'
    }),
    agreement: localize({
        ru: 'Я даю согласие на обработку своих персональных данных. С <z-link target="_blank" href="/personal-data-policy/">Политикой ООО «ИНК» в области обработки персональных данных</z-link> и текстом <z-link target="_blank" href="/personal-data-policy/">согласия на обработку персональных данных</z-link> ознакомлен, возражений не имею.',
        en: 'I agree to the processing of my personal data. With <z-link target="_blank" href="/personal-data-policy/">Policy of LLC "INK" in the field of personal data processing</z-link> and the text of <z-link target="_blank" href="/personal-data-policy/">consent to the processing of personal data</z-link>',
        cn: 'I agree to the processing of my personal data. With <z-link target="_blank" href="/personal-data-policy/">Policy of LLC "INK" in the field of personal data processing</z-link> and the text of <z-link target="_blank" href="/personal-data-policy/">consent to the processing of personal data</z-link>'
    }),
    required: localize({
        ru: 'Поля помеченные * обязательны для заполнения',
        en: '',
        cn: ''
    }),
    submit: localize({
        ru: 'Отправить',
        en: 'Submit',
        cn: 'Submit'
    }),
    success: localize({
        ru: 'Данные успешно отправлены',
        en: '',
        cn: ''
    }),
    sendError: localize({
        ru: 'Что-то пошло не так, попробуйте позже',
        en: 'Something went wrong, please try again later',
        cn: 'Something went wrong, please try again later'
    })
}

export { textLocalize }
